import { Model, MapTo } from 'src/app/decorators/mapto';

export class DiscountModel extends Model {
    @MapTo()
    id: string;
    @MapTo()
    staff_id: string;
    @MapTo()
    staff_name: string;
    @MapTo()
    rate: number;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }

    get Id(): string {
        return this.id || null;
    }
}
